
import Card from '@/components/material/Card.vue';
import DlgEventGuestDelete from '@/modules/admin/events/_components/DlgEventGuestDelete.vue';

import DlgEventSendGuestEmail from '@/modules/admin/events/_components/DlgEventSendGuestEmail.vue';
import DlgGroupSelector from '@/modules/admin/groups/_components/DlgGroupSelector.vue';
import DlgGuestNew from '@/modules/admin/guests/_components/DlgGuestNew.vue';
import DlgGuestSelector from '@/modules/admin/guests/_components/DlgGuestSelector.vue';
import DlgGuestUpdate from '@/modules/admin/guests/_components/DlgGuestUpdate.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import DlgEventInvitationEdit from '@/modules/admin/events/_components/DlgEventInvitationEdit.vue';
import DlgGuestImportCSV from "@/modules/admin/guests/_components/DlgGuestImportCSV.vue";

@Component({
             components: {
               DlgGuestImportCSV,
               DlgGuestUpdate,
               DlgEventInvitationEdit,
               DlgEventSendGuestEmail, DlgGuestSelector, DlgGuestNew, DlgGroupSelector, Card, DlgEventGuestDelete,
             },
           })
export default class EventGuests extends Vue {
  public $refs!: {
    form: any,
    dlgGroup: any,
    dlgGuests: any,
  };
  @Prop({type: String, default: ''}) private search!: string;

  @Action('admin/events/readGuests') private readGuests!: (params: any) => Promise<any>;
  @Action('admin/events/addGuests') private addGuests!: (params: any) => Promise<any>;
  @Action('admin/groups/readOne') private readGroup!: (params: any) => Promise<any>;

  @Getter('admin/events/one') public event!: any;
  @Getter('admin/groups/one') private group!: any;
  @Getter('admin/events/guests') public guests!: any;

  public statusFilter: number = this.$route.query.type ? Number(this.$route.query.type) : -1;
  public guestSearch: string = '';
  public loading: boolean = false;
  public sendGuestEmailGuest: object = {};
  public sendGuestEmailDlg: boolean = false;
  public dlgEditInvitation: boolean = false;
  public dlgEditGuest: boolean = false;
  public dlgGuest: object = {};

  public status: any = [
    {
      text: 'Alle',
      value: -1,
    },
    {
      text: 'Angenommen',
      value: 70,
    },
    {
      text: 'Ausstehend',
      value: 0,
    },
    {
      text: 'Abgelehnt',
      value: 99,
    },
  ];

  public headers: any = [
    {
      text: 'Status',
      value: 'status',
      align: 'left',
    },
    {
      text: 'Email',
      align: 'left',
      value: 'email',
    },
    {
      text: 'Name',
      value: 'surname',
      align: 'left',
    },
    {
      text: 'Eingeladen durch',
      value: 'invitedBy',
      align: 'left',
    },
    {
      text: 'Aktualisiert am',
      value: 'updatedAt',
      align: 'left',
    },
    {
      text: 'Email Status',
      value: 'emailStatus',
      align: 'left',
    },
    {
      text: '',
      value: '',
      align: 'left',
    },
  ];

  public items: any = [
    {title: 'Bearbeiten'},
    {title: 'Löschen'},
  ];

  private mounted() {
    this.init();
  }

  public async loadGuests() {
    await this.readGuests({id: this.event.id});
  }

  public async init() {
    this.loading = true;
    await this.loadGuests();
    if (this.$route.query.type) {
      this.statusFilter = Number(this.$route.query.type);
      const el = document.querySelector('#guestCard');
      if (el) {
        el.scrollIntoView();
      }
    }
    this.loading = false;
  }

  public async addGuest(guest) {
    this.loading = true;
    await this.addGuests({id: this.event.id, guests: [guest.id]});
    await this.readGuests({id: this.event.id});
    this.loading = false;
  }

  public async selectedGuest(guest) {
    this.loading = true;
    await this.addGuests({id: this.event.id, guests: [guest.id]});
    await this.readGuests({id: this.event.id});
    this.$refs.dlgGuests.close();
    this.loading = false;
  }

  public guestSearchChanged(e) {
    this.guestSearch = e;
  }

  public async importGroup(group) {
    this.loading = true;
    await this.readGroup({id: group.id});

    const ids: string[] = [];

    this.group.members.forEach((member) => {
      ids.push(member.guestId);
    });

    await this.addGuests({id: this.event.id, guests: ids});
    this.$refs.dlgGroup.close();
    await this.readGuests({id: this.event.id});
    this.loading = false;
  }

  public sendGuestEmail(guest) {
    this.sendGuestEmailGuest = guest;
    this.sendGuestEmailDlg = true;
  }

  public editInvitation(guest) {
    this.dlgGuest = JSON.parse(JSON.stringify(guest));
    this.dlgEditInvitation = true;
  }

  public editGuest(guest) {
    this.dlgGuest = JSON.parse(JSON.stringify(guest));
    this.dlgEditGuest = true;
  }

  public onGuestsImported() {
    this.loadGuests();
  }

  get filteredGuests() {
    if (this.statusFilter === -1) {
      return this.guests;
    } else {
      return this.guests.filter((guest) => guest.status === this.statusFilter);
    }
  }
}
